// REACT
import React, { useState, useRef } from "react";

// IONIC
import {
  IonSegment,
  IonSegmentButton,
  IonRow,
  IonCol,
  IonGrid,
  IonSlides,
  IonSlide,
  IonText,
  IonImg,
  IonIcon,
  IonBadge,
  IonButton,
  IonModal,
} from "@ionic/react";
import {
  arrowBackCircle,
  arrowForwardCircle,
  expand,
  ticket,
} from "ionicons/icons";

// Media
import vergleichspreis from "../../assets/images/Vergleichspreis.png";
import freizeitangebote from "../../assets/images/Freizeitangebote.png";
import sehenswuerdigkeiten from "../../assets/images/Sehenswuerdigkeiten.png";

//Data
import UserService from "../../Context/user.service";
import Constants from "../../Context/constants";
import Helpers from "../../Context/helpers";

//import Segment from '../components/Segment';
function Tab(props) {
  //Token + login + pro data
  var userInitial = 0;
  var logedInInitial = false;
  var isProinitial = false;
  var tokenInitial = "";

  const tokenData = UserService.getUserData();

  if (typeof tokenData["tokenData"].MerchantCustomerId !== "undefined") {
    userInitial = tokenData["tokenData"].MerchantCustomerId;
    logedInInitial = true;

    if (tokenData.login == 1) {
      logedInInitial = true;
    }
    if (tokenData.pro == 1) {
      isProinitial = true;
    }

    tokenInitial = tokenData.cookie;
  }

  const [error, setError] = useState(null);

  // a ref variable to handle the current slider
  const slider = useRef();
  // a state value to bind segment value
  const [value, setValue] = useState("0");
  //Login + token + pro
  const [token, setToken] = useState(tokenInitial);
  const [user, setUser] = useState(userInitial);
  const [isPro, setIsPro] = useState(isProinitial);
  const [isVoucherModalOpen, setIsVoucherModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [validContent, setValidContent] = useState("");
  const [emailRecipient, setEmailRecipient] = useState("");
  const [textVoucher, setTextVoucher] = useState("");
  const [voucherID, setVoucherID] = useState();

  // Voucher
  let foundValidVoucher = false;

  function clickVoucher(voucherId, emailRec, textV, validF) {
    if (isPro) {
      
      if (today >= validF) {
        UserService.getUsedVouchers(user, token).then(
          (response) => {
            for (let i = 0; i <= response.data[0].vouchers.length; i++) {
              if (response.data[0].vouchers[i] === voucherId) {
                setIsVoucherModalOpen(true);
                setModalContent("usedVoucher");
                break;
              } else {
                setIsVoucherModalOpen(true);
                setVoucherID(voucherId)
                setModalContent("newVoucher");
                setEmailRecipient(emailRec);
                setTextVoucher(textV.replaceAll("%", "%25"));
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
      } else {
        setIsVoucherModalOpen(true);
        setModalContent("notValid");
        setValidContent(changeDateFormat(validF));
      }
    } else {
      if (typeof window.parent.setPaywallModal !== "undefined") {
        window.parent.setPaywallModal("pro");
      }
    }
  }

  function redeemVoucher() {
    UserService.saveUsedVoucher(voucherID, user, token);

UserService.goToURL(
      `${window.config.wppath}/voucher-einloesen/?emailto=${emailRecipient}?text=${textVoucher}`
    )  }




  // Modal for Vouchers

  function closeModal() {
    setIsVoucherModalOpen(false);
  }

  function onWillDismiss() {
    setIsVoucherModalOpen(false);
  }

  // Date
  var date = new Date();
  var currentDay = String(date.getDate()).padStart(2, "0");
  var currentMonth = String(date.getMonth() + 1).padStart(2, "0");
  var currentYear = date.getFullYear();
  let today = currentYear + "-" + currentMonth + "-" + currentDay;

  function changeDateFormat(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [day, month, year].join(".");
  }

  //Lightbox
  const [lightboxDisplay, setLightBoxDisplay] = useState(false);
  const [imageToShow, setImageToShow] = useState("");

  const slideOpts = {
    initialSlide: 0,
    speed: 400,
    loop: false,
    pagination: {
      el: null,
    },
  };

  // a function to handle the segment changes
  const handleSegmentChange = async (e) => {
    setValue(e.detail.value);
    slider.current.slideTo(e.detail.value);
  };

  // a function to handle the slider changes
  const handleSlideChange = async (e) => {
    let index = 0;
    await e.target.getActiveIndex().then((value) => {
      index = value;
      let ionSlide = document.querySelector("ion-slide.swiper-slide-active");
      slider.current.style.height = ionSlide.clientHeight.toString() + "px";
    });
    setValue("" + index);

    /*     let nextSlide = document.querySelectorAll(".swiper-slide-next");
     */
    /* let activeSlide = document.querySelectorAll(".swiper-slide-active");
    let activeSlideHeight = activeSlide[0].clientHeight;




    e.target.style.height = `${activeSlideHeight}px`; */
  };

  // Lightbox
  const imagesArray = [];
  props.images !== undefined &&
    props.images.map((item) => {
      imagesArray.push({
        path: item.imagepath,
        credit: item.credits,
      });
    });
  // Voucher
  let foundValidVoucherTab = false;

  const showImage = (image) => {
    //set imageToShow to be the one that's been clicked on
    setImageToShow(
      `https://verwaltung.bordatlas.de/proxy/img/${image}?width=800`
    );
    //set lightbox visibility to true
    setLightBoxDisplay(true);
  };

  const hideLightBox = () => {
    setLightBoxDisplay(false);
  };

  const showNext = (e) => {
    e.stopPropagation();

    let currentIndex = imagesArray.findIndex(
      (p) =>
        p.path ===
        imageToShow
          .replaceAll("https://verwaltung.bordatlas.de/proxy/img/", "")
          .replaceAll("?width=800", "")
    );

    if (currentIndex >= imagesArray.length - 1) {
      setLightBoxDisplay(false);
    } else {
      let nextImage = imagesArray[currentIndex + 1].path;
      setImageToShow(
        `https://verwaltung.bordatlas.de/proxy/img/${nextImage}?width=800`
      );
    }
  };

  const showPrev = (e) => {
    e.stopPropagation();
    let currentIndex = imagesArray.findIndex(
      (p) =>
        p.path ===
        imageToShow
          .replaceAll("https://verwaltung.bordatlas.de/proxy/img/", "")
          .replaceAll("?width=800", "")
    );
    if (currentIndex <= 0) {
      setLightBoxDisplay(false);
    } else {
      let prevImage = imagesArray[currentIndex - 1].path;
      setImageToShow(
        `https://verwaltung.bordatlas.de/proxy/img/${prevImage}?width=800`
      );
    }
  };

  function decode(str) {
    let txt = document.createElement("div");
    txt.innerHTML = str;
    var realtext = txt.innerText.replaceAll("&nbsp;", "\u00A0");
    return realtext;
  }

  function extraPrice(item) {
    const decodedValues = [];

    for (const [key, value] of Object.entries(item)) {
      const decodedValue = decode(`${value}`);
      const paragraph = (
        <span>
          {decodedValue}
          <br />
        </span>
      );
      decodedValues.push(paragraph);
    }

    return decodedValues;
  }

  return (
    <>
      {/* MODAL */}
      <IonModal
        isOpen={isVoucherModalOpen}
        id="vouchermodal"
        onWillDismiss={() => onWillDismiss()}
      >
        {modalContent === "usedVoucher" ? (
          <div className="vouchermodal__wrapper">
            <div className="vouchermodal__text">
              <p className="p__big">
                Du hast diesen Gutschein bereits eingelöst.
              </p>
            </div>
            <IonButton
              size="small"
              shape="round"
              color="secondary"
              onClick={() => closeModal()}
            >
              Schließen
            </IonButton>
          </div>
        ) : modalContent === "newVoucher" ? (
          <div className="vouchermodal__wrapper">
            <div className="vouchermodal__text">
              <p className="p__big">
                Möchtest du diesen Gutschein jetzt einlösen?
              </p>{" "}
            </div>
            <IonButton
              shape="round"
              color="primary"
              onClick={() => redeemVoucher()}
            >
              Ja
            </IonButton>
            <IonButton
              shape="round"
              color="secondary"
              onClick={() => closeModal()}
            >
              Nein
            </IonButton>
          </div>
        ) : (
          modalContent === "notValid" && (
            <div className="vouchermodal__wrapper">
              <div className="vouchermodal__text">
                <p className="p__big">
                  Dieser Gutschein ist noch nicht gültig. Du kannst diesen
                  Gutschein ab dem <b>{validContent} </b>einlösen.
                </p>
              </div>{" "}
              <IonButton
                size="small"
                shape="round"
                color="secondary"
                onClick={() => closeModal()}
              >
                Schließen
              </IonButton>
            </div>
          )
        )}
      </IonModal>
      {/*-- Segment in a toolbar --*/}
      {/*-- the value is binded to state value and is updated every time setValue is running --*/}
      {/*-- buttons values are set to 0 and 1, to match slider index, it can be whatever you need but there mas be a table --*/}
      <IonSegment
        color="secondary"
        value={value}
        onIonChange={(e) => handleSegmentChange(e)}
      >
        <IonSegmentButton value="0">
          <IonText>Informationen</IonText>
        </IonSegmentButton>
        <IonSegmentButton value="1">
          <IonText>Kosten</IonText>
        </IonSegmentButton>
        <IonSegmentButton value="2">
          <IonText>Aktivitäten</IonText>
        </IonSegmentButton>
        <IonSegmentButton value="3">
          <IonText>Fotos</IonText>
        </IonSegmentButton>

        {props.voucher !== undefined &&
          props.voucher.forEach((item) => {
            item.dateranges.daterange.map((items) => {
              if (today <= items.validUntil) {
                foundValidVoucherTab = true;
              }
            });
          })}
        {foundValidVoucherTab && (
          <>
            <IonSegmentButton value="4">
              <IonText>Gutschein</IonText>
            </IonSegmentButton>
          </>
        )}
      </IonSegment>

      {/*-- Market Segment --*/}
      {/*-- the ref method binds this slider to slider variable --*/}
      <IonSlides
        pager={true}
        options={slideOpts}
        onIonSlideDidChange={(e) => handleSlideChange(e)}
        ref={slider}
      >
        <IonSlide className="ion-text-start">
          <IonGrid>
            <IonRow>
              {props.url === "" ? (
                <IonCol
                  className="pitch__background__image "
                  size="12"
                  size-sm="6"
                  style={{
                    background: `url('/wp-content/uploads/2023/04/Symbolbild1_c_Hardy-Mutschler_Muster.jpg') no-repeat center`,
                  }}
                ></IonCol>
              ) : (
                <IonCol
                  className="pitch__background__image "
                  size="12"
                  size-sm="6"
                  style={{
                    background: `url('${props.url}') no-repeat center`,
                  }}
                ></IonCol>
              )}

              <IonCol size="12" size-sm="6" className="pitch__information">
                <p style={{ marginTop: 0 }}>
                  {props.category !== "common_pitch" && (
                    <>
                      <span
                        className={`font__icon infocard__icon_category ${Constants.categoryFontMapping[props.category]}`}
                        style={{ fontSize: "16px", marginRight: "5px" }}
                      >
                        {Constants.categoryFontMapping[props.category]}
                      </span> 
                      {Constants.categoryNameMapping[props.category]} <br />
                    </>
                  )}
                </p>
                <h4 color="primary">
                  {props.anzahlStellplaetze !== undefined && (
                    <>
                      <span className="font__icon">R </span>
                      {(props.caravanAvailable === "Ja" ||
                        props.caravanAvailable === "ja") &&
                        props.anzahlCaravans === "0" && (
                          <span className="font__icon">y </span>
                        )}
                      {props.anzahlStellplaetze} Stellplätze{" "}
                    </>
                  )}
                  {props.stellplaetzeLaenge !== undefined && (
                    <>bis {props.stellplaetzeLaenge} m Länge </>
                  )}
                  {(props.caravanAvailable === "Ja" ||
                    props.caravanAvailable === "ja") &&
                    props.anzahlCaravans !== "0" && (
                      <h4 color="primary">
                        {props.anzahlStellplaetze !== undefined && (
                          <>
                            <span className="font__icon">y </span>
                            {props.anzahlCaravans} Stellplätze{" "}
                          </>
                        )}
                        {props.caravanLaenge !== undefined && (
                          <>bis {props.caravanLaenge} m Länge </>
                        )}
                      </h4>
                    )}
                </h4>
                <p className="p__big">
                  <b>
                    auf
                    {props.untergrund.map((item, index) => {
                      return (
                        <span>
                          {" "}
                          {item}
                          {props.untergrund.length - index !== 1 && ","}
                        </span>
                      );
                    })}
                  </b>
                </p>
                
                {props.umweltzone === "ja" && (
                  <IonBadge color="success">Umweltzone</IonBadge>
                )}{" "}
                {props.labelpreis !== undefined && (
                  <IonBadge color="secondary">
                    {decode(props.labelpreis)}
                  </IonBadge>
                )}{" "}
                {props.voucher !== undefined &&
                  props.voucher.forEach((item) => {
                    item.dateranges.daterange.map((items) => {
                      if (today <= items.validUntil) {
                        foundValidVoucher = true;
                      }
                    });
                  })}
                {foundValidVoucher && (
                  <IonSegment
                    color="light"
                    value={value}
                    onIonChange={(e) => handleSegmentChange(e)}
                    className="segment__voucher"
                  >
                    <div className="ion-align-items-center information__voucher">
                      <br />
                      <IonSegmentButton value="4" className="segment__voucher">
                        <IonBadge
                          color="primary"
                          className="infocard__badge__voucher ion-margin-end"
                        >
                          <IonIcon icon={ticket}></IonIcon>
                        </IonBadge>{" "}
                      </IonSegmentButton>

                      <p>Gutschein nur im Abo erhältlich</p>
                    </div>
                  </IonSegment>
                )}{" "}
                {props.premiumValue === "1" && (
                  <IonBadge color="tertiary">Premium-Stellplatz</IonBadge>
                )}
              </IonCol>
              <IonCol size="12">
                {props.premiumValue === "1" && (
                  <p class="pitch__premium">{props.premiumText}</p>
                )}
              </IonCol>
            </IonRow>
            {props.platzbeschreibung !== "" && (
              <IonRow className="border__bottom">
                <IonCol size="12" size-sm="6" className="pitch__heading">
                  <p>
                    <b>Platzbeschreibung</b>
                  </p>
                </IonCol>
                <IonCol size="12" size-sm="6" className="pitch__information">
                  <p>{props.platzbeschreibung}</p>
                </IonCol>
              </IonRow>
            )}
            {props.aufenthalt.length !== 0 && (
              <IonRow className="border__bottom">
                <IonCol size="12" size-sm="6" className="pitch__heading">
                  <p>
                    <b>Details</b>
                  </p>
                </IonCol>
                <IonCol size="12" size-sm="6" className="pitch__information">
                  <p>{decode(props.aufenthalt)}</p>
                </IonCol>
              </IonRow>
            )}

            {props.oeffnungszeiten !== "" && (
              <IonRow className="border__bottom">
                <IonCol size="12" size-sm="6" className="pitch__heading">
                  <p>
                    <b>Öffnungszeiten</b>
                  </p>
                </IonCol>
                <IonCol size="12" size-sm="6" className="pitch__information">
                  <p>
                    {decode(props.oeffnungszeiten)
                      .split("<br />")
                      .reduce((acc, curr, index) => {
                        return acc.concat(
                          index > 0 ? [<br key={index} />, curr] : [curr]
                        );
                      }, [])}
                  </p>
                </IonCol>
              </IonRow>
            )}
            {props.anfahrt.length !== 0 && (
              <IonRow className="border__bottom">
                <IonCol size="12" size-sm="6" className="pitch__heading">
                  <p>
                    <b>Anfahrt</b>
                  </p>
                </IonCol>
                <IonCol size="12" size-sm="6" className="pitch__information">
                  <p>{props.anfahrt}</p>
                </IonCol>
              </IonRow>
            )}
            {(props.ausgewiesenValue === "Ja" ||
              props.ausgewiesenValue === "ja") && (
              <IonRow className="border__bottom">
                <IonCol size="12" size-sm="6" className="pitch__heading">
                  <p>
                    <b>Stellplatz ausgewiesen</b>
                  </p>
                </IonCol>
                <IonCol size="12" size-sm="6" className="pitch__information">
                  <p>{props.ausgewiesenValue}</p>
                </IonCol>
              </IonRow>
            )}
            {props.reservierung.length !== 0 && (
              <IonRow className="border__bottom">
                <IonCol size="12" size-sm="6" className="pitch__heading">
                  <p>
                    <b>Reservierung</b>
                  </p>
                </IonCol>
                <IonCol size="12" size-sm="6" className="pitch__information">
                  {props.reservierung === "no" ? (
                    <p>Nein</p>
                  ) : props.reservierung === "yes" ? (
                    <p>Ja </p>
                  ) : (
                    <p>{props.reservierung} </p>
                  )}
                </IonCol>
              </IonRow>
            )}
            {props.entfernungen.length !== 0 && (
              <IonRow className="border__bottom">
                <IonCol size="12" size-sm="6" className="pitch__heading">
                  <p>
                    <b>Entfernungen</b>
                  </p>
                </IonCol>
                <IonCol size="12" size-sm="6" className="pitch__information">
                  <p>
                    {props.entfernungen.entfernung.length !== 0 &&
                      props.entfernungen.entfernung.map((item) => {
                        return (
                          <table className="table table-hover table-striped">
                            <tr className="tr__s">
                              <td className="font__icon ">
                                {item.entfernungIcon}
                              </td>
                            </tr>
                            <tr className="tr__l">
                              <td>
                                {" "}
                                {item.entfernungString}{" "}
                                {item.entfernungDistance.length === 0
                                  ? "0"
                                  : item.entfernungDistance}{" "}
                                km{" "}
                              </td>
                            </tr>
                          </table>
                        );
                      })}
                  </p>
                </IonCol>
              </IonRow>
            )}

            {props.gastronomie.length !== 0 && (
              <IonRow className="border__bottom">
                <IonCol size="12" size-sm="6" className="pitch__heading">
                  <p>
                    {" "}
                    <b>Gastronomie</b>
                  </p>
                </IonCol>
                <IonCol size="12" size-sm="6" className="pitch__information">
                  <p>{decode(props.gastronomie)}</p>
                </IonCol>
              </IonRow>
            )}
            {typeof props.ausstattung !== "undefined" && (
              <IonRow className="border__bottom">
                <IonCol size="12" size-sm="6" className="pitch__heading">
                  <p>
                    <b>Ausstattung</b>
                  </p>
                </IonCol>
                <IonCol size="12" size-sm="6" className="pitch__information">
                  <p>
                    {props.ausstattung.map((item) => {
                      return (
                        <>
                          {" "}
                          <table className="table table-hover table-striped">
                            <tr className="tr__s">
                              <td className="font__icon ">
                                {item.featureIcon.length !== 0 ? (
                                  item.featureIcon
                                ) : (
                                  <span> &nbsp; </span>
                                )}
                              </td>
                            </tr>
                            <tr className="tr__l">
                              <td> {item.featureString} </td>
                            </tr>
                          </table>
                        </>
                      );
                    })}
                  </p>
                </IonCol>
              </IonRow>
            )}
            {props.stellplatztyp === "Stellplatz mit Entsorgungsstation" && (
              <IonRow>
                <IonCol size="12" size-sm="6" className="pitch__heading">
                  <p>
                    <b>Entsorgung</b>
                  </p>
                </IonCol>{" "}
                <IonCol size="12" size-sm="6" className="pitch__information">
                <p>
                  {props.entsorgungsstation.features.length !== 0 &&
                    props.entsorgungsstation.features.feature.map((item) => {
                      if (item.symbol === "l" || item.symbol === "k") {
                        return (
                          <>
                            <table className="table table-hover table-striped">
                              <tr className="tr__s">
                                <td className="font__icon">
                                  {item.symbol}
                                </td>
                              </tr>
                              <tr className="tr__l">
                                <td>
                                  {" "}
                                  {item.anmerkung}
                                </td>
                              </tr>{" "}
                            </table>
                          </>
                        );
                      }
                    })}    </p>
<p>
                  {props.entsorgungsstation.system.length !== 0 && (
                    <>
                      <tr>
                        <td className="slide__table__left">
                         System:{" "}
                        </td>
                        <td className="slide__table__right">
                         {props.entsorgungsstation.system}
                        </td>
                      </tr>
                    </>
                  )}</p>
                  {props.entsorgungsstation.durchreise.length !== 0 && (
                    <p>{props.entsorgungsstation.durchreise}</p>
                  )}
                </IonCol>
              </IonRow>
            )}
          </IonGrid>
        </IonSlide>
        {/*-- Package Segment --*/}

        <IonSlide>
          <IonGrid className="ion-text-start">
            <>
              {props.vergleichspreis.length !== 0 && (
                <IonRow className="border__bottom">
                  <IonCol size="4" size-sm="6" className="display_flex">
                    <IonImg
                      src={vergleichspreis}
                      className="icon_costs"
                    ></IonImg>
                  </IonCol>
                  <IonCol size="8" size-sm="6" className="pitch__information">
                    <p>
                      <b>Preis (Reisemobil & 2 Personen)</b>
                    </p>
                    {props.vergleichspreis.generalPrice !== undefined && (
                      <p>
                        <b>
                          {decode(props.vergleichspreis.generalPrice)}{" "}
                          {props.vergleichspreis.inklusives.length !== 0 && (
                            <span>
                              inkl. {props.vergleichspreis.inklusives}
                            </span>
                          )}{" "}
                        </b>
                      </p>
                    )}
                    <br />
                    {props.vergleichspreis.extra !== undefined && (
                      <>
                        <p>Preis für Service</p>
                        <p>{extraPrice(props.vergleichspreis.extra)}</p>
                      </>
                    )}
                    <br />
                    {props.vergleichspreis.kommentar !== undefined && (
                      <p>{decode(props.vergleichspreis.kommentar)}</p>
                    )}
                  </IonCol>
                </IonRow>
              )}
            </>
            {props.voucher !== undefined &&
              props.voucher.map((item) => {
                let jsxElements = [];
                item.dateranges.daterange.map((items) => {
                  if (today <= items.validUntil) {
                    jsxElements.push(
                      <IonRow className="column__voucher ion-padding">
                        <IonRow
                          style={{
                            width: "100%",
                          }}
                          className="ion-justify-content-between"
                        >
                          <div className="ion-align-items-center voucher__tab__heading">
                            <IonIcon
                              icon={ticket}
                              size="large"
                              color="light"
                              className="ion-margin-end"
                            ></IonIcon>
                            <h4>
                              Dein BORDATLAS-Vorteil: <br />
                              {item.name}
                            </h4>
                          </div>{" "}
                          <div>
                            <h2>{Helpers.formatNumberString(item.value)}€</h2>
                          </div>
                        </IonRow>
                        <IonRow
                          className=" ion-align-items-end"
                          style={{
                            width: "100%",
                          }}
                        >
                          <IonCol size="12" size-lg="6" size-xl="8">
                            <p className="p__big">{item.benefit}</p>
                            <p className="p__big">
                              <b>
                                Gültigkeit: {changeDateFormat(items.validFrom)}{" "}
                                - {changeDateFormat(items.validUntil)}
                              </b>
                            </p>{" "}
                            <p>{item.howToDigital}</p>
                          </IonCol>
                          <IonCol
                            size="12"
                            size-lg="6"
                            size-xl="4"
                            className="ion-text-end ion-align-items-end"
                          >
                            {" "}
                            <IonButton
                              color="primary"
                              shape="round"
                              onClick={() =>
                                clickVoucher(
                                  item.id,
                                  item.email !== "" ? props.email : item.email,
                                  props.postcode + " " + props.city + ", " + props.name + ", " + item.name + ", Wert: " + item.value + "€",
                                  items.validFrom
                                )
                              }
                            >
                              Gutschein einlösen
                            </IonButton>
                          </IonCol>
                        </IonRow>
                      </IonRow>
                    );
                  }
                });
                return jsxElements;
              })}
          </IonGrid>
        </IonSlide>
        <IonSlide>
          <IonGrid className="ion-text-start">
            {props.freizeitangebote.length !== 0 && (
              <IonRow className="border__bottom">
                <IonCol size="4" size-sm="6" className="display_flex">
                  <IonImg
                    src={freizeitangebote}
                    className="icon_costs"
                  ></IonImg>
                </IonCol>
                <IonCol size="8" size-sm="6" className="pitch__information ">
                  <p>
                    <b>Freizeitangebote</b>
                  </p>

                  <p>{decode(props.freizeitangebote)}</p>
                </IonCol>
              </IonRow>
            )}
            {props.sehenswuerdigkeiten.length !== 0 && (
              <IonRow className="border__bottom">
                <IonCol size="4" size-sm="6" className="display_flex">
                  <IonImg
                    src={sehenswuerdigkeiten}
                    className="icon_costs_small"
                  ></IonImg>
                </IonCol>
                <IonCol size="8" size-sm="6" className="pitch__information">
                  <p>
                    <b>Sehenswürdigkeiten</b>
                  </p>
                  <p>{decode(props.sehenswuerdigkeiten)}</p>
                </IonCol>
              </IonRow>
            )}
            {props.sehenswuerdigkeiten.length === 0 &&
              props.freizeitangebote.length === 0 && (
                <IonCol>
                  <p>Keine Aktivitäten vorhanden</p>
                </IonCol>
              )}
          </IonGrid>
        </IonSlide>
        <IonSlide>
          <IonGrid>
            {imagesArray.length !== 0 ? (
              <IonRow>
                {imagesArray.map((item) => {
                  return (
                    <IonCol size="12" size-sm="6" className="ion-text-start">
                      <img
                        src={`https://verwaltung.bordatlas.de/proxy/img/${item.path}?width=400`}
                        onClick={() => showImage(item.path)}
                        alt=""
                      />
                      <IonIcon
                        icon={expand}
                        className="images_expand"
                        onClick={() => showImage(item.path)}
                      ></IonIcon>
                      <span className="font__small">Foto: {item.credit}</span>
                    </IonCol>
                  );
                })}
              </IonRow>
            ) : (
              <IonCol>
                <p>Noch keine Bilder vorhanden</p>
              </IonCol>
            )}
          </IonGrid>
        </IonSlide>
        <IonSlide>
          <IonGrid className="ion-text-start">
            {props.voucher !== undefined &&
              props.voucher.map((item) => {
                let jsxElements = [];
                item.dateranges.daterange.map((items) => {
                  if (today <= items.validUntil) {
                    jsxElements.push(
                      <IonRow className="column__voucher ion-padding">
                        <IonRow
                          style={{
                            width: "100%",
                          }}
                          className="ion-justify-content-between"
                        >
                          <div className="ion-align-items-center voucher__tab__heading">
                            <IonIcon
                              icon={ticket}
                              size="large"
                              color="light"
                              className="ion-margin-end"
                            ></IonIcon>
                            <h4>
                              Dein BORDATLAS-Vorteil: <br />
                              {item.name}
                            </h4>
                          </div>{" "}
                          <div>
                            <h2>{Helpers.formatNumberString(item.value)}€</h2>
                          </div>
                        </IonRow>
                        <IonRow
                          className=" ion-align-items-end"
                          style={{
                            width: "100%",
                          }}
                        >
                          <IonCol size="12" size-lg="6" size-xl="8">
                            <p className="p__big">{item.benefit}</p>
                            <p className="p__big">
                              <b>
                                Gültigkeit: {changeDateFormat(items.validFrom)}{" "}
                                - {changeDateFormat(items.validUntil)}
                              </b>
                            </p>{" "}
                            <p>{item.howToDigital}</p>
                          </IonCol>
                          <IonCol
                            size="12"
                            size-lg="6"
                            size-xl="4"
                            className="ion-text-end ion-align-items-end"
                          >
                            {" "}
                            <IonButton
                              color="primary"
                              shape="round"
                              onClick={() =>
                                clickVoucher(
                                  item.id,
                                  item.email !== "" ? props.email : item.email,
                                  props.postcode + " " + props.city + ", " + props.name + ", " + item.name + ", Wert: " + item.value + "€",
                                  items.validFrom
                                )
                              }
                            >
                              Gutschein einlösen
                            </IonButton>
                          </IonCol>
                        </IonRow>
                      </IonRow>
                    );
                  }
                });
                return jsxElements;
              })}
          </IonGrid>
        </IonSlide>
      </IonSlides>

      {lightboxDisplay ? (
        <div id="lightbox" onClick={hideLightBox}>
          <IonButton
            className="lightbox__button"
            color="primary"
            shape="round"
            size="small"
            onClick={showPrev}
          >
            <IonIcon icon={arrowBackCircle}></IonIcon>
          </IonButton>

          <img id="lightbox-img" src={imageToShow}></img>
          <IonButton
            className="lightbox__button"
            color="primary"
            shape="round"
            size="small"
            onClick={showNext}
          >
            <IonIcon icon={arrowForwardCircle}></IonIcon>
          </IonButton>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default Tab;
